var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "business-data-section" } },
    [
      _vm.hasMoneyPayment
        ? _c(
            "base-notificator",
            {
              staticClass: "_mt-2",
              attrs: { type: "info", "can-close": false },
            },
            [
              _vm._v("\n        " + _vm._s(_vm.hadPaymentText) + "\n        "),
              _c(
                "a",
                {
                  staticClass: "gfu-link _tdu",
                  attrs: {
                    rel: "noopener noreferrer",
                    href: _vm.contactUrl,
                    target: "_blank",
                  },
                },
                [_vm._v("contact us")]
              ),
              _vm._v(".\n    "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("option-field", {
        attrs: {
          name: "model.accountType",
          "display-name": "Account Type",
          layout: "columns",
          options: _vm.accountTypeOptions,
          description:
            "Defines if the account belongs to an individual creator or a company. Business - Registered legal entity (e.g., LLC, Inc.). Individual - Uses personal bank account or bank account established on a sole proprietorship.",
          required: "",
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "account-type",
        },
        on: { input: _vm.onAccountTypeChange },
        model: {
          value: _vm.model.accountType,
          callback: function ($$v) {
            _vm.$set(_vm.model, "accountType", $$v)
          },
          expression: "model.accountType",
        },
      }),
      _vm._v(" "),
      _vm.isBusiness
        ? _c("text-field", {
            attrs: {
              name: "model.companyName",
              "display-name": "Company name",
              layout: "columns",
              "read-only": _vm.hasMoneyPayment,
              "data-qa": "company-name",
            },
            model: {
              value: _vm.model.companyName,
              callback: function ($$v) {
                _vm.$set(_vm.model, "companyName", $$v)
              },
              expression: "model.companyName",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isBusiness
        ? _c("text-field", {
            attrs: {
              name: "model.fullName",
              "display-name": "Full Name",
              layout: "columns",
              description: "Name as shown on your ID document.",
              "read-only": _vm.hasMoneyPayment,
              "data-qa": "full-name",
            },
            model: {
              value: _vm.model.fullName,
              callback: function ($$v) {
                _vm.$set(_vm.model, "fullName", $$v)
              },
              expression: "model.fullName",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("text-field", {
        attrs: {
          name: "model.email",
          "display-name": "Email address",
          layout: "columns",
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "email",
        },
        model: {
          value: _vm.model.email,
          callback: function ($$v) {
            _vm.$set(_vm.model, "email", $$v)
          },
          expression: "model.email",
        },
      }),
      _vm._v(" "),
      _c("option-field", {
        attrs: {
          name: "model.twoLetterIsoCode",
          "display-name": "Country",
          layout: "columns",
          options: _vm.countryOptions,
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "country",
        },
        on: { input: _vm.onCountryInput },
        model: {
          value: _vm.model.twoLetterIsoCode,
          callback: function ($$v) {
            _vm.$set(_vm.model, "twoLetterIsoCode", $$v)
          },
          expression: "model.twoLetterIsoCode",
        },
      }),
      _vm._v(" "),
      _c(
        "text-field",
        {
          attrs: {
            name: "model.taxId",
            "display-name": "VAT ID/Tax Identification Number",
            layout: "columns",
            description:
              "Defines if the account belongs to an individual creator or a company.",
            "read-only": _vm.hasMoneyPayment,
            "data-qa": "tax-id",
          },
          on: { input: _vm.onTaxIdChange },
          model: {
            value: _vm.model.taxId,
            callback: function ($$v) {
              _vm.$set(_vm.model, "taxId", $$v)
            },
            expression: "model.taxId",
          },
        },
        [
          _vm._t("description", function () {
            return [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isTaxIdDescriptionVisible,
                      expression: "isTaxIdDescriptionVisible",
                    },
                  ],
                },
                [
                  _c("base-icon", {
                    staticClass: "_mr-1",
                    attrs: { name: "circle-info" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.taxIdFieldDescription))]),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("text-field", {
        attrs: {
          name: "model.street",
          "display-name": "Street",
          layout: "columns",
          description: "The name of the street.",
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "street",
        },
        model: {
          value: _vm.model.street,
          callback: function ($$v) {
            _vm.$set(_vm.model, "street", $$v)
          },
          expression: "model.street",
        },
      }),
      _vm._v(" "),
      _c("text-field", {
        attrs: {
          name: "model.streetNumber",
          "display-name": "House/unit number",
          layout: "columns",
          description: "The number or name of the house.",
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "house-number",
        },
        model: {
          value: _vm.model.streetNumber,
          callback: function ($$v) {
            _vm.$set(_vm.model, "streetNumber", $$v)
          },
          expression: "model.streetNumber",
        },
      }),
      _vm._v(" "),
      _c("text-field", {
        attrs: {
          name: "model.city",
          "display-name": "City",
          layout: "columns",
          description: "The name of the city.",
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "city",
        },
        model: {
          value: _vm.model.city,
          callback: function ($$v) {
            _vm.$set(_vm.model, "city", $$v)
          },
          expression: "model.city",
        },
      }),
      _vm._v(" "),
      _c("text-field", {
        attrs: {
          name: "model.state",
          "display-name": "State",
          layout: "columns",
          description: "State or province.",
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "state",
        },
        model: {
          value: _vm.model.state,
          callback: function ($$v) {
            _vm.$set(_vm.model, "state", $$v)
          },
          expression: "model.state",
        },
      }),
      _vm._v(" "),
      _c("text-field", {
        attrs: {
          name: "model.postalCode",
          "display-name": "Postal code",
          layout: "columns",
          description: "The postal code.",
          "read-only": _vm.hasMoneyPayment,
          "data-qa": "postal-code",
        },
        model: {
          value: _vm.model.postalCode,
          callback: function ($$v) {
            _vm.$set(_vm.model, "postalCode", $$v)
          },
          expression: "model.postalCode",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }